var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.svgContent)?_c('div',{staticClass:"svg-container",domProps:{"innerHTML":_vm._s(_vm.svgContent)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }